<template>
  <div class="paid-wrapper">
    <span class="paid-text">
      Sua parcela foi paga com sucesso!
    </span>
  </div>
</template>

<script>
export default {
  name: 'PaidWarning',
};
</script>

<style lang="scss" scoped>
@import '@/scss/__new-styles.scss';

.paid-wrapper {
  position: relative;
  grid-column-start: 1;
  grid-column-end: 3;

  display: none;
  width: 100%;
  height: 56px;

  padding: 16px 20px;
  margin-bottom: -4px;
  top: -24px;

  background-color: var(--green-100);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  @media (min-width: $lg) {
    display: inline-block;
  }
}

.paid-text {
  @extend .body-bold;
  color: var(--green-300)
}
</style>
